import * as React from 'react';
import emptyImage from 'src/assets/emptyInvoicesImage';

import './EmptyPayments.scss';

class EmptyPayments extends React.Component<any, any> {
  public render() {
    return (
      <div className="rp-empty-payments row">
        <div className="col-12 d-flex justify-content-center align-items-end">
          <img src={emptyImage} className="img-fluid" />
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <h1 className="rp-empty-payments-title">
            You Have No Payments To Manage
          </h1>
        </div>
      </div>
    );
  }
}

export default EmptyPayments;
